var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 2.40001C14.4 2.26369 14.3651 2.12966 14.2987 2.01062C14.2323 1.89159 14.1365 1.7915 14.0206 1.71985C13.9046 1.6482 13.7723 1.60738 13.6361 1.60124C13.4999 1.59511 13.3644 1.62387 13.2425 1.68481L7.0105 4.80001H4.0001C3.36358 4.80001 2.75313 5.05286 2.30304 5.50295C1.85295 5.95304 1.6001 6.56349 1.6001 7.20001C1.6001 7.83653 1.85295 8.44698 2.30304 8.89706C2.75313 9.34715 3.36358 9.60001 4.0001 9.60001H4.2241L5.6409 13.8528C5.69398 14.0122 5.79587 14.1508 5.93214 14.249C6.0684 14.3472 6.23213 14.4 6.4001 14.4H7.2001C7.41227 14.4 7.61575 14.3157 7.76578 14.1657C7.91581 14.0157 8.0001 13.8122 8.0001 13.6V10.0944L13.2425 12.7152C13.3644 12.7761 13.4999 12.8049 13.6361 12.7988C13.7723 12.7926 13.9046 12.7518 14.0206 12.6802C14.1365 12.6085 14.2323 12.5084 14.2987 12.3894C14.3651 12.2704 14.4 12.1363 14.4001 12V2.40001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphone);
export default __webpack_public_path__ + "static/media/Speakerphone.b571832d1edf69587e59d58b864d67e4.svg";
export { ForwardRef as ReactComponent };